import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Lightning, SoccerBall } from '@phosphor-icons/react';

const words = ['Football', 'Soccer'];

export const CookieFeatureBlock = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % words.length);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-16 sm:py-20 bg-[#050B14]" data-testid="cookie-feature-block">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Left — Icon + Title */}
          <div className="text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-3 mb-4">
              <AnimatePresence mode="wait">
                <motion.div
                  key={index}
                  initial={{ rotateY: 90, opacity: 0 }}
                  animate={{ rotateY: 0, opacity: 1 }}
                  exit={{ rotateY: -90, opacity: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {index === 0 ? (
                    <Lightning size={40} weight="fill" className="text-[#FFD700]" />
                  ) : (
                    <SoccerBall size={40} weight="fill" className="text-[#FFD700]" />
                  )}
                </motion.div>
              </AnimatePresence>
              <h2 className="font-['Bebas_Neue'] text-4xl sm:text-5xl lg:text-6xl uppercase text-white leading-none">
                0% Cookies.{' '}
                <span className="inline-block relative">
                  100%{' '}
                  <AnimatePresence mode="wait">
                    <motion.span
                      key={words[index]}
                      initial={{ y: 30, opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      exit={{ y: -30, opacity: 0 }}
                      transition={{ duration: 0.35 }}
                      className="inline-block text-[#FFD700]"
                    >
                      {words[index]}.
                    </motion.span>
                  </AnimatePresence>
                </span>
              </h2>
            </div>
          </div>

          {/* Right — Description */}
          <div>
            <p className="text-gray-400 text-base sm:text-lg leading-relaxed text-center lg:text-left">
              Our zero-cookie infrastructure makes our map <strong className="text-white">30% faster on mobile</strong>. No crumbs, no tracking—just the game.
            </p>
            <div className="flex items-center gap-6 mt-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
                <span className="text-green-400 text-xs font-bold uppercase tracking-wider">Privacy-First</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-[#FFD700]" />
                <span className="text-[#FFD700] text-xs font-bold uppercase tracking-wider">Zero Cookies</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-[#FF6B35]" />
                <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-wider">Fast Load</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
